import blockStyles from '../../types/blockStyles';

export const blockHTMLMap = {
    [blockStyles.H1]: 'h1',
    [blockStyles.H2]: 'h2',
    [blockStyles.H3]: 'h3',
    [blockStyles.H4]: 'h4',
    [blockStyles.H5]: 'h5',
    [blockStyles.H6]: 'h6',
    [blockStyles.BLOCKQUOTE]: 'blockquote',
    [blockStyles.CODE_BLOCK]: 'code',
    [blockStyles.UNSTYLED]: 'p',
    [blockStyles.ATOMIC]: 'figure',
    [blockStyles.UL]: 'li',
    [blockStyles.OL]: 'li',
};
